import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Menu, MenuItem, TableCell } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Invoice, InvoiceMenuCellProps } from "../../../../payment.types";
import APP_ROUTES from "../../../../../../routers/routeConstants";
import {
  PaymentTableDownloadInvoiceIcon,
  PaymentTableInvoiceMenuIcon,
  PaymentTableViewInvoiceIcon,
} from "../../../../../../assets/icons/MUI/PaymentIcons";

const invoice: Invoice = {
  goalngoWebsite: "www.website.com",
  goalngoEmail: "hello@email.com",
  goalngoNumber: "+91 00000 00000",
  entityAddress: "City, State, IN - 000 000",
  taxId: "00XXXXX1234X0XX",
  billedToAddress: "1234 Elm Street, Springfield, USA - 62704",
  billedToName: "John Doe",
  billedToPhoneNum: "+1 (217) 555-1234",
  reference: "INV-1001",
  invoiceNumber: "#AB2324-01",
  invoiceDate: "2023-08-15",
  dueDate: "2023-09-15",
  subject: "MEMBERSHIP",
  description: [
    {
      itemName: "Annual Membership",
      quantity: 1,
      unitPrice: 1500,
      amount: 1500,
    },
  ],
  subtotal: 1500,
  total: 1500,
  amountDue: 1500,
  currency: "USD",
  items: [
    { description: "Service A", quantity: 1, unitPrice: 800, total: 800 },
    { description: "Service B", quantity: 2, unitPrice: 350, total: 700 },
    { description: "Product C", quantity: 3, unitPrice: 150, total: 450 },
    { description: "Additional Fee", quantity: 1, unitPrice: 500, total: 500 },
  ],
};

export const InvoiceMenuCell = ({ handleOnDownloadInvoice }: InvoiceMenuCellProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleDownloadInvoice = () => {
    handleOnDownloadInvoice(invoice);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOnClickOnViewPaymentLinks = () => {
    navigate(APP_ROUTES.PAYMENT_LINKS);
    setAnchorEl(null);
  };

  return (
    <TableCell>
      <IconButton onClick={handleClick}>
        <PaymentTableInvoiceMenuIcon />
      </IconButton>
      <Menu
        id="invoice-menu"
        aria-labelledby="invoice-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleDownloadInvoice} sx={{ display: "flex", gap: "8px" }}>
          <PaymentTableDownloadInvoiceIcon />
          {t("pages.payment.paymentLinks.downloadInvoice")}
        </MenuItem>
        <MenuItem onClick={handleOnClickOnViewPaymentLinks} sx={{ display: "flex", gap: "8px" }}>
          <PaymentTableViewInvoiceIcon />
          {t("pages.payment.paymentLinks.viewPaymentLink")}
        </MenuItem>
      </Menu>
    </TableCell>
  );
};
